export default "__VITE_ASSET__DvwjNatR__"